import { render, staticRenderFns } from "./Affiliate.vue?vue&type=template&id=2c6491f0&"
import script from "./Affiliate.vue?vue&type=script&lang=js&"
export * from "./Affiliate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports